import React, { Component } from "react";
import {
  Button,
  Grid,
  Typography,
  withStyles,
  Box,
  Dialog,
  CircularProgress,
  Divider,
  IconButton,
} from "@material-ui/core";
import { Check, CheckBoxRounded, Close } from "@material-ui/icons";

class ConfirmationDialog extends Component {
  render() {
    const { classes, openDialog, closeDialog, title } = this.props;
    const { body, action, loader } = this.props;
    const mobileScreen = window.innerWidth < 767 ? true : false;
    return (
      <Dialog
        open={openDialog}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        fullWidth={mobileScreen}
      >
        {openDialog && (
          <div className={classes.root}>
            <Box className={classes.title}>
              <Typography variant="h3">
                {title}
              </Typography>
              <IconButton onClick={closeDialog} className={classes.closeButton}>
                <Close />
              </IconButton>
            </Box>
            <Divider />
            <Box className={classes.body}>
              <>{body}</>
            </Box>
            <Divider />
            {/* <Box my={6} /> */}
            <Grid container className={classes.actions}>
              <Grid item>
                <Button variant="outlined" onClick={closeDialog}>Cancel</Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={action}
                  disabled={loader}
                  endIcon={loader ? <CircularProgress size={20} /> : <Check size={20} />}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  title: {
    backgroundColor: "#ffffff",
    padding: "6px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  root: {
    maxWidth: "500px",
    minHeight: 150,
    // padding: "20px",
    // height: "70vh",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
    color: "black",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: 200,
    },
  },
  actions: {
    padding: "14px",
    justifyContent: "end",
    gap: "12px"
  },
  body: {
    backgroundColor: "#ffffff",
    padding: "16px"
  },
  closeButton: {
    marginRight: "-8px"
  }
});

export default withStyles(styles)(ConfirmationDialog);
